import { Button } from 'components/ui';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { FormattedMessage } from 'react-intl';
import Cancel from 'components/inspection/modal/cancel';

const CancelButton = ({ inspection, refetch }) => {
  const { addModal, removeModal } = useModal();
  const setInfo = useInfo();

  return (
    <Button
      variant="outlined"
      disabled={inspection.canceled}
      onClick={() => {
        addModal(
          <Cancel
            inspection={inspection}
            handleClose={() => removeModal()}
            onSuccess={() => {
              refetch();
              removeModal();
              setInfo('info.inspection.canceled');
            }}
          />,
          { disableAutoFocus: true, disableRestoreFocus: true }
        );
      }}
    >
      <FormattedMessage id="button.cancel" />
    </Button>
  );
};

export default CancelButton;
